import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// ================================================使用路由懒加载=========================================================

// // 登录
const loginNew = () => import(/* webpackChunkName:"login" */ '@/login/login-new')
const TermsService = () => import(/* webpackChunkName:"login" */ '@/login/terms-service') // 服务条款
const FileLink = () => import(/* webpackChunkName:"external" */ '@/external/file-link') // 下载共享文件
const Api = () => import(/* webpackChunkName:"external" */ '@/external/api') // api文档
const ApplicationList = () =>
  import(/* webpackChunkName:"external" */ '@/external/application-list') // 应用中心
const notFound = () => import(/* webpackChunkName:"error" */ '@/error/notFound') // 404

// // 企业前台
const Frontend = () => import(/* webpackChunkName:"frontend" */ '@/frontend/main-frontend') // TF前台主界面
const Workbench = () => import(/* webpackChunkName:"workbench" */ '@/frontend/workbench/workbench') // 工作台
const EmployeeHierarchy = () =>
  import(/* webpackChunkName:"employeeHierarchy" */ '@/frontend/workbench/employee-hierarchy') // 组织架构
const WtaskList = () => import(/* webpackChunkName:"wtaskList" */ '@/frontend/workbench/wtask-list') // 待办任务
const Schedule = () => import(/* webpackChunkName:"schedule" */ '@/frontend/workbench/schedule') // 日程
const SSO = () => import(/* webpackChunkName:"sso" */ '@/frontend/workbench/sso') // 单点登录
const SSODetail = () => import(/* webpackChunkName:"SSODetail" */ '@/frontend/workbench/sso-detail') // 单点登录详情
const DataModule = () => import(/* webpackChunkName:"dataModule" */ '@/frontend/module/module-main') // 自定义模块
const ModuleListReport = () =>
  import(/* webpackChunkName:"moduleListReport" */ '@/frontend/module/module-list-report-box') // 自定义数据分析
const Approval = () => import(/* webpackChunkName:"approval" */ '@/frontend/approval/approval-main') // 审批模块
const Assistant = () =>
  import(/* webpackChunkName:"assistant" */ '@/frontend/companyLetter/assistant') // 助手
const Library = () => import(/* webpackChunkName:"library" */ '@/frontend/library/library-main-new') // 文件库
const Memo = () => import(/* webpackChunkName:"memo" */ '@/frontend/memo/memo-main') // 备忘录
const Knowledge = () =>
  import(/* webpackChunkName:"knowledge" */ '@/frontend/knowledge/knowledge-main') // 知识库
const KnowledgeDetail = () =>
  import(/* webpackChunkName:"knowledgeDetail" */ '@/frontend/knowledge/knowledge-detail') // 知识库详情
const EmailMain = () => import(/* webpackChunkName:"emailMain" */ '@/frontend/Email/Email-main') // 邮件主页
const EmailInbox = () =>
  import(/* webpackChunkName:"emailInbox" */ '@/frontend/Email/Email_interface/inbox') // 邮件收件箱
const EmailSent = () =>
  import(/* webpackChunkName:"emailSent" */ '@/frontend/Email/Email_interface/sent') // 邮件已发送
const EmailDrafts = () =>
  import(/* webpackChunkName:"emailDrafts" */ '@/frontend/Email/Email_interface/drafts') // 邮件草稿箱
const EmailDeleted = () =>
  import(/* webpackChunkName:"emailDeleted" */ '@/frontend/Email/Email_interface/deleted') // 邮件已删除
const EmailDustbin = () =>
  import(/* webpackChunkName:"emailDustbin" */ '@/frontend/Email/Email_interface/dustbin') // 邮件垃圾箱
const EmailLabelPage = () =>
  import(/* webpackChunkName:"emailLabelPage" */ '@/frontend/Email/Email_interface/labelPage') // 邮件标签
const EmailEpistolize = () =>
  import(/* webpackChunkName:"emailEpistolize" */ '@/frontend/Email/components/Email-epistolize') // 邮件写信
const Emailpreview = () =>
  import(/* webpackChunkName:"emailpreview" */ '@/common/components/preview-epistolize') // 邮件预览
const EmailSet = () =>
  import(/* webpackChunkName:"emailSet" */ '@/frontend/Email/mail-set/mail-set') // 邮件设置
const MailAddress = () =>
  import(/* webpackChunkName:"mailAddress" */ '@/frontend/Email/components/mail-address') // 通讯录
const definedReport2 = () =>
  import(/* webpackChunkName:"DataReportMain" */ '@/frontend/statistic_analysis/data-report-main') // 自定义报表主体(新版)2024-03-13
const dataAnalystSetting = () =>
  import(
    /* webpackChunkName:"dataAnalystsetting" */ '@/frontend/statistic_analysis/component/dataAnalyst-setting-new'
  )
const dataAnalystDesign = () =>
  import(
    /* webpackChunkName:"dataAnalystDesign" */ '@/frontend/statistic_analysis/component/dataAnalyst-design-new'
  )

/**
 * 企业管理后台
 */

const Backend = () => import(/* webpackChunkName:"backendmain" */ '@/backend/backend') // 后台主界面
const EnterpriseMain = () =>
  import(/* webpackChunkName:"enterpriseMain" */ '@/backend/enterprise/enterprise-main') // 企业管理
const EnterpriseIndex = () =>
  import(/* webpackChunkName:"enterpriseIndex" */ '@/backend/enterprise/main') // 企业管理 - 首页
const EnterpriseBasicInfo = () =>
  import(/* webpackChunkName:"enterpriseBasicInfo" */ '@/backend/enterprise/basic-info') // 企业管理 - 基本信息
const SafetyMain = () =>
  import(/* webpackChunkName:"safetyMain" */ '@/backend/enterprise/safety/safety-main') // 企业管理 - 安全管理
const SmsMain = () => import(/* webpackChunkName:"smsMain" */ '@/backend/enterprise/sms/sms-main') // 企业管理 - 安全管理

const AccountCenterMain = () =>
  import(/* webpackChunkName:"accountCenterMain" */ '@/backend/account/main') // 账户中心=
const employeeMain = () =>
  import(/* webpackChunkName:"employeeMain" */ '@/backend/account/employee') // 账户中心
const roleMain = () => import(/* webpackChunkName:"roleMain" */ '@/backend/account/role') // 账户中心
const Isolation = () => import(/* webpackChunkName:"isolation" */ '@/backend/account/isolation') // 账户中心 - 通讯录隔离

const CustomMain = () => import(/* webpackChunkName:"customMain" */ '@/backend/custom/main') // 应用管理
const ModuleSettingMain = () =>
  import(/* webpackChunkName:"moduleSettingMain" */ '@/backend/module_setting/module-setting-main') // 应用管理 - 基础模块
// const ApplicationMain = () => import(/* webpackChunkName:"applicationMain" */ '@/backend/application/application-main.2') // 应用管理 - 应用中心
const JuHeMain = () => import(/* webpackChunkName:"juHeMain" */ '@/backend/custom/forms/juhe-main') // 应用管理 - 聚合表
const JuHeCreate = () =>
  import(/* webpackChunkName:"juHeCreate" */ '@/backend/custom/forms/juhe-create') // 应用管理 - 聚合表
const CustomMain2 = () =>
  import(/* webpackChunkName:"customMain2" */ '@/backend/custom/custom-main') // 应用管理列表
const CustomModule = () =>
  import(/* webpackChunkName:"customModule" */ '@/backend/custom/modules/custom-module') // 自定义管理
const ReportList = () =>
  import(/* webpackChunkName:"reportlist" */ '@/backend/custom/forms/report-list') // 后台数据分析列表

const DataCenterMain = () => import(/* webpackChunkName:"dataCenterMain" */ '@/backend/data/main') // 数据中心
const RecycleMain = () => import(/* webpackChunkName:"recycleMain" */ '@/backend/data/recycle') // 数据中心 - 回收站
const ToDoData = () => import(/* webpackChunkName:"toDoData" */ '@/backend/data/toDoData') // 数据中心 - 待办数据

const IntegrationMain = () =>
  import(/* webpackChunkName:"integrationMain" */ '@/backend/integration/main') // 接口集成
const IntegrationCustom = () =>
  import(/* webpackChunkName:"integrationcustom" */ '@/backend/integration/custom') // 接口集成 - 自定义接口
const thirdPartyPlatform = () =>
  import(/* webpackChunkName:"thirdpartyplatform" */ '@/backend/integration/third-party-platform') // 接口集成 - 第三方接口
const InterfaceSetting = () =>
  import(/* webpackChunkName:"interfacesetting" */ '@/backend/integration/interface-setting') // 接口集成
const interfacePlugIn = () =>
  import(/* webpackChunkName:"interfacePlugIn" */ '@/backend/integration/plug-in') // 接口集成 - 插件下载
const ssoManage = () =>
  import(/* webpackChunkName:"ssomanage" */ '@/backend/integration/sso-manage') // 接口集成 - 插件下载-单点登录
const resumeManage = () =>
  import(/* webpackChunkName:"resumemanage" */ '@/backend/integration/resume-manage') // 接口集成 - 插件下载-简历
const BusinessManage = () =>
  import(/* webpackChunkName:"businessmanage" */ '@/backend/integration/business-manage') // 接口集成 - 插件下载-名片
const Exhibition = () =>
  import(/* webpackChunkName:"exhibition" */ '@/backend/integration/exhibition/exhibition') // 接口集成 - 插件下载-展会设置

const TemplateMain = () =>
  import(/* webpackChunkName:"templateMain" */ '@/backend/platform_template/main') // 平台模版
const TargetTemplate = () =>
  import(/* webpackChunkName:"targettemplate" */ '@/backend/platform_template/target') // 平台模版 - 绩效指标
const AppraisalTemplate = () =>
  import(
    /* webpackChunkName:"appraisaltemplate" */ '@/backend/platform_template/appraisal-template'
  ) // 平台模版 - 考核模板
const AppraisalTemplateSetting = () =>
  import(
    /* webpackChunkName:"appraisalTemplateSetting" */ '@/frontend/performance/template-setting'
  ) // 平台模版 - 设置模板
const PlatformTemplate = () =>
  import(
    /* webpackChunkName:"platformtemplate" */ '@/backend/platform_template/platform_template_main'
  ) // 平台模版
const PlatformCommonFields = () =>
  import(
    /* webpackChunkName:"platformCommonFields" */ '@/backend/platform_template/platform_common_fields'
  ) // 平台模版 - 常用字段设置
const PlatformTemlateList = () =>
  import(
    /* webpackChunkName:"platformTemlateList" */ '@/backend/platform_template/platform_temlate_list'
  ) // 平台模版 - 模版模块列表
const PlatformTemplateModule = () =>
  import(
    /* webpackChunkName:"platformTemplateModule" */ '@/backend/platform_template/platform_template_module'
  ) // 平台模版 - 模版模块布局
const SrlTemplate = () =>
  import(/* webpackChunkName:"srlTemplate" */ '@/backend/platform_template/srl-template') // 胜任力模板

// 自定义模块
const CustomLayout = () =>
  import(/* webpackChunkName:"customLayout" */ '@/backend/custom/layout/custom-layout-main') // 自定义模块布局界面
const CustomContent = () =>
  import(/* webpackChunkName:"customcontent" */ '@/backend/custom/layout/custom-content') // 自定义内容
const CustomApproval = () =>
  import(/* webpackChunkName:"customapproval" */ '@/backend/custom/layout/custom-approval-x6') // 自定义流程审批
const CustomWebform = () =>
  import(/* webpackChunkName:"customwebform" */ '@/backend/custom/layout/custom-webform') // 自定义WEB表单
const CustomSettings = () =>
  import(/* webpackChunkName:"customsettings" */ '@/backend/custom/layout/custom-settings') // 自定义全局设置
const CustomoPerationFlow = () =>
  import(
    /* webpackChunkName:"customoperationflow" */ '@/backend/custom/layout/custom-operation-flow-x6'
  ) // 自定业务流程
const DataAuth = () =>
  import(/* webpackChunkName:"dataauth" */ '@/backend/custom/layout/setting/data-auth') // 自定义全局设置--数据权限
const FieldDepend = () =>
  import(/* webpackChunkName:"fielddepend" */ '@/backend/custom/layout/setting/field-depend') // 自定义全局设置--字段依赖
const FieldTransfer = () =>
  import(/* webpackChunkName:"fieldtransfer" */ '@/backend/custom/layout/setting/field-transfer') // 自定义全局设置--字段转换
const RecordStyle = () =>
  import(/* webpackChunkName:"recordstyle" */ '@/backend/custom/layout/setting/record-style') // 自定义全局设置--记录样式
const WorkflowAuto = () =>
  import(/* webpackChunkName:"workflowauto" */ '@/backend/custom/layout/setting/workflow-auto') // 自定义全局设置--工作流自动化
const HighSeas = () =>
  import(/* webpackChunkName:"highseas" */ '@/backend/custom/layout/setting/high-seas') // 自定义全局设置--公海池
const NotSeasRule = () =>
  import(/* webpackChunkName:"highseas" */ '@/backend/custom/layout/setting/not-seas-rule') // 自定义全局设置--非公海池规则
const NoticePush = () =>
  import(/* webpackChunkName:"noticepush" */ '@/backend/custom/layout/setting/notice-push') // 自定义全局设置--消息推送
const PrintSetting = () =>
  import(/* webpackChunkName:"printsetting" */ '@/backend/custom/layout/setting/print-setting') // 自定义全局设置--打印设置
const DataShare = () =>
  import(/* webpackChunkName:"datashare" */ '@/backend/custom/layout/setting/data-share') // 自定义全局设置--数据共享
const PageAuth = () =>
  import(/* webpackChunkName:"pageauth" */ '@/backend/custom/layout/setting/page-auth') // 自定义全局设置--页面权限
const RecordLocking = () =>
  import(/* webpackChunkName:"recordlocking" */ '@/backend/custom/layout/setting/record-locking') // 自定义全局设置--记录锁定
const AutoMatch = () =>
  import(/* webpackChunkName:"automatch" */ '@/backend/custom/layout/setting/auto-match') // 自定义全局设置--自动化匹配
const TabManage = () =>
  import(/* webpackChunkName:"tabmanage" */ '@/backend/custom/layout/setting/tab-manage') // 自定义全局设置--页签管理
const SubMenu = () =>
  import(/* webpackChunkName:"submenu" */ '@/backend/custom/layout/setting/sub-menu') // 自定义全局设置--子菜单
const OutLinks = () =>
  import(/* webpackChunkName:"outlinks" */ '@/backend/custom/layout/setting/out-links') // 自定义全局设置--外部链接
const SubmitCheck = () =>
  import(/* webpackChunkName:"submitcheck" */ '@/backend/custom/layout/setting/submit-check') // 自定义全局设置--提交校验
const ShortMessageTemplate = () =>
  import(
    /* webpackChunkName:"shortmessagetempalte" */ '@/backend/custom/layout/setting/short-message-tempalte'
  ) // 自定义全局设置--短信模板
const CustomButton = () =>
  import(/* webpackChunkName:"custombutton" */ '@/backend/custom/layout/setting/custom-button') // 自定义全局设置--自定义按钮
const CheckRepeatSetting = () =>
  import(
    /* webpackChunkName:"checkrepeatsetting" */ '@/backend/custom/layout/setting/check-repeat-setting'
  ) // 自定义全局设置--查重设置
const SmartPlugIn = () =>
  import(/* webpackChunkName:"smartplugin" */ '@/backend/custom/layout/setting/smart-plug-in') // 自定义全局设置--智能插件
const MapModeSetting = () =>
  import(/* webpackChunkName:"mapmodesetting" */ '@/backend/custom/layout/setting/map-mode-setting') // 自定义全局设置--地图设置

/**
 * 后台基础模块设置
 */
const WorkbenchManage = () =>
  import(
    /* webpackChunkName:"workbenchManage" */ '@/backend/module_setting/workbench_setting/workbench-main copy'
  ) // 工作台后台列表
const WorkbenchSetting = () =>
  import(
    /* webpackChunkName:"workbenchSetting" */ '@/backend/module_setting/workbench_setting/workbench-setting-copy'
  ) // 工作台后台设置
const KnowledgeManage = () =>
  import(
    /* webpackChunkName:"knowledgeManage" */ '@/backend/module_setting/knowledge_manage/knowledge-main'
  ) // 知识库管理
const LibraryManage = () =>
  import(
    /* webpackChunkName:"libraryManage" */ '@/backend/module_setting/library_manage/library-main'
  ) // 文件库管理
const approvalManage = () =>
  import(/* webpackChunkName:"approvalManage" */ '@/backend/approval_manage/approval-manage') // 审批管理
const CooperationBackend = () =>
  import(
    /* webpackChunkName:"cooperationBackend" */ '@/backend/module_setting/cooperation/cooperation-backend'
  ) // 基础模块设置的协作任务
const MailBackstageMain = () =>
  import(/* webpackChunkName:"mailBackstageMain" */ '@/backend/mail_manage/mail-manage') // 邮件管理
const PersonnelMatrix = () =>
  import(/* webpackChunkName:"personnelMatrix" */ '@/backend/module_setting/personnel_matrix/index') // 人员矩阵
const MatrixDetails = () =>
  import(
    /* webpackChunkName:"matrixDetails" */ '@/backend/module_setting/personnel_matrix/matrix_details/index'
  ) // 人员矩阵详情

// // 独立路由
const AppReview = () => import(/* webpackChunkName:"appReview" */ '@/independent/app-review') // 应用预览
const mailDetailPage = () =>
  import(/* webpackChunkName:"mailDetailPage" */ '@/frontend/Email/components/mail-detail-page') // 邮件详情
const juheCreate = () =>
  import(/* webpackChunkName:"juheCreate" */ '@/backend/custom/forms/juhe-create') // 聚合表新增组件
const DataLinkDetails = () =>
  import(/* webpackChunkName:"dataLinkDetails" */ '@/frontend/module/data-link-details') // 数据外链
const BackendReportDesign = () =>
  import(/* webpackChunkName:"backendReportDesign" */ '@/backend/custom/backend-report-design') // 后台数据分析设计页面
const BackendReportSetting = () =>
  import(/* webpackChunkName:"backendReportSetting" */ '@/backend/custom/backend-report-setting') // 后台数据分析编辑页面
const SocialSecurityScheme = () =>
  import(
    /* webpackChunkName:"socialSecurityScheme" */ '@/backend/socialSecurityScheme/social-securitys-scheme'
  ) // 后台社保方案设置
// 文件下载权限
const FileDownloadAuth = () =>
  import(
    /* webpackChunkName:"attenHandlChange" */ '@/backend/custom/layout/setting/file-download-auth'
  ) // 文件下载权限

const CustomDetailsPrintPage = () =>
  import(
    /* webpackChunkName:"CustomDetailsPrintPage" */ '@/frontend/module/components/custom-details-print-page'
  ) // 自定义打印

Vue.use(Router)

const router = new Router({
  // mode: 'history', // 需前后端都配置后才可使用
  routes: [
    {
      path: '/',
      name: 'login',
      component: loginNew
    },
    {
      path: '/404',
      name: 'notFound',
      component: notFound
    },
    {
      path: '/termsService',
      name: 'TermsService',
      component: TermsService
    },
    {
      path: '/fileLink',
      name: 'FileLink',
      component: FileLink
    },
    {
      path: '/api',
      name: 'Api',
      component: Api
    },
    {
      path: '/Emailpreview',
      name: 'Emailpreview',
      component: Emailpreview
    },
    {
      path: '/workbenchSetting',
      name: 'WorkbenchSetting',
      component: WorkbenchSetting
    },
    {
      path: '/knowledgeDetail',
      name: 'KnowledgeDetail',
      component: KnowledgeDetail
    },
    {
      path: '/backendReportDesign',
      name: 'BackendReportDesign',
      component: BackendReportDesign
    },
    {
      path: '/backendReportSetting',
      name: 'BackendReportSetting',
      component: BackendReportSetting
    },
    {
      path: '/ssoDetail',
      name: 'SSODetail',
      component: SSODetail
    },
    {
      path: '/application',
      name: 'ApplicationList',
      component: ApplicationList
    },
    /** 单点登录 */
    {
      path: '/sso',
      name: 'SSO2',
      component: SSO
    },
    /** 企业前台路由 */
    {
      path: '/frontend',
      name: 'Frontend',
      component: Frontend,
      children: [
        /** 工作台 */
        {
          path: 'workbench',
          name: 'Workbench',
          component: Workbench,
          meta: {
            keepAlive: true
          }
        },
        /** 组织架构 */
        {
          path: 'hierarchy',
          name: 'EmployeeHierarchy',
          component: EmployeeHierarchy,
          meta: {
            keepAlive: true
          }
        },
        /** 日程 */
        {
          path: 'schedule',
          name: 'Schedule',
          component: Schedule,
          meta: {
            keepAlive: true
          }
        },
        /** 待办任务 */
        {
          path: 'wtask',
          name: 'WtaskList',
          component: WtaskList,
          meta: {
            keepAlive: true
          }
        },
        /** 单点登录 */
        {
          path: 'sso',
          name: 'SSO',
          component: SSO,
          meta: {
            keepAlive: true
          }
        },
        /** 消息列表 */
        {
          path: 'assistant',
          name: 'Assistant',
          component: Assistant
        },
        {
          path: 'definedReportMain',
          name: 'definedReportMain',
          component: definedReport2 /** 自定义报表设置 */
        },
        {
          path: 'dataAnalystSetting',
          name: 'dataAnalystSetting',
          component: dataAnalystSetting
        },
        {
          path: 'dataAnalystDesign',
          name: 'dataAnalystDesign',
          component: dataAnalystDesign
        },
        {
          path: 'definedReport',
          name: 'definedReport',
          component: definedReport2 /** 自定义报表 */
        },
        // 自定义列表
        {
          path: 'module',
          name: 'DataModule',
          component: DataModule
        },
        {
          path: 'moduleListReport',
          name: 'ModuleListReport',
          component: ModuleListReport
        },
        // 审批
        {
          path: 'approval',
          name: 'Approval',
          component: Approval /** 审批模块的路由 */
        },
        {
          path: 'EmailMain',
          name: 'EmailMain',
          component: EmailMain /** 邮件 */,
          children: [
            {
              path: 'EmailInbox',
              name: 'EmailInbox',
              component: EmailInbox
            },
            {
              path: 'EmailSent',
              name: 'EmailSent',
              component: EmailSent
            },
            {
              path: 'EmailDrafts',
              name: 'EmailDrafts',
              component: EmailDrafts
            },
            {
              path: 'EmailDeleted',
              name: 'EmailDeleted',
              component: EmailDeleted
            },
            {
              path: 'EmailDustbin',
              name: 'EmailDustbin',
              component: EmailDustbin
            },
            {
              path: 'EmailLabelPage',
              name: 'EmailLabelPage',
              component: EmailLabelPage
            },
            {
              path: 'EmailEpistolize',
              name: 'EmailEpistolize',
              component: EmailEpistolize
            },
            {
              path: 'EmailSet',
              name: 'EmailSet',
              component: EmailSet
            },
            {
              path: 'MailAddress',
              name: 'MailAddress',
              component: MailAddress
            }
          ]
        },
        {
          path: 'library',
          name: 'Library',
          component: Library
        },
        {
          path: 'knowledge',
          name: 'Knowledge',
          component: Knowledge
        },
        /** 备忘录 */
        {
          path: 'memo',
          name: 'Memo',
          component: Memo
        }
      ]
    },
    // 自定义详情打印
    {
      path: '/customDetailsPrintPage',
      name: 'CustomDetailsPrintPage',
      component: CustomDetailsPrintPage
    },
    /** 企业管理后台 */
    {
      path: '/backend',
      name: 'Backend',
      component: Backend,
      children: [
        // 企业管理
        {
          path: 'enterprise',
          name: 'EnterpriseMain',
          component: EnterpriseMain,
          children: [
            {
              path: 'main',
              name: 'EnterpriseIndex',
              component: EnterpriseIndex
            },
            {
              path: 'basic',
              name: 'EnterpriseBasicInfo',
              component: EnterpriseBasicInfo
            },
            {
              path: 'safety',
              name: 'SafetyMain',
              component: SafetyMain
            },
            {
              path: 'sms',
              name: 'SmsMain',
              component: SmsMain
            }
          ]
        },
        // 账户中心
        {
          path: 'account',
          name: 'AccountCenterMain',
          component: AccountCenterMain,
          children: [
            {
              path: 'employee',
              name: 'employeeMain',
              component: employeeMain
            },
            {
              path: 'role',
              name: 'roleMain',
              component: roleMain
            },
            {
              path: 'isolation',
              name: 'Isolation',
              component: Isolation
            }
            // {
            //   path: 'orgInterconnection',
            //   name: 'OrgInterconnection',
            //   component: OrgInterconnection
            // }
          ]
        },
        // 应用管理
        {
          path: 'custom',
          name: 'CustomMain',
          component: CustomMain,
          children: [
            {
              path: 'basicModule',
              name: 'ModuleSettingMain',
              component: ModuleSettingMain
            },
            // {
            //   path: 'application',
            //   name: 'ApplicationMain',
            //   component: ApplicationMain
            // },
            {
              path: 'customMain2',
              name: 'CustomMain2',
              component: CustomMain2
            }
          ]
        },
        // 聚合表创建页面
        {
          path: 'juHeCreate',
          name: 'JuHeCreate',
          component: JuHeCreate
        },
        // 自定义模块列表
        {
          path: 'module',
          name: 'CustomModule',
          component: CustomModule
        },
        // 聚合表首页
        {
          path: 'juHeMain',
          name: 'JuHeMain',
          component: JuHeMain
        },
        // 数据分析
        {
          path: 'reportList',
          name: 'ReportList',
          component: ReportList
        },
        // 审批
        {
          path: 'approvalManage',
          name: 'approvalManage',
          component: approvalManage
        },
        // 协作
        {
          path: 'cooperationBackend',
          name: 'CooperationBackend',
          component: CooperationBackend
        },
        // 数据中心
        {
          path: 'data',
          name: 'DataCenterMain',
          component: DataCenterMain,
          children: [
            {
              path: 'recycle',
              name: 'RecycleMain',
              component: RecycleMain
            },
            {
              path: 'toDoData',
              name: 'ToDoData',
              component: ToDoData
            },
            {
              path: 'taskMonitoring',
              name: 'TaskMonitoring',
              component: () => import('@/backend/data/task-monitoring')
            }
          ]
        },
        // 接口集成
        {
          path: 'integration',
          name: 'IntegrationMain',
          component: IntegrationMain,
          children: [
            {
              path: 'custom',
              name: 'IntegrationCustom',
              component: IntegrationCustom
            },
            {
              path: 'third',
              name: 'thirdPartyPlatform',
              component: thirdPartyPlatform
            },
            {
              path: 'plugIn',
              name: 'interfacePlugIn',
              component: interfacePlugIn
            }
          ]
        },
        // 接口集成
        {
          path: 'interfaceSetting',
          name: 'InterfaceSetting',
          component: InterfaceSetting
        },
        // 接口集成-单点登录管理
        {
          path: 'sso',
          name: 'ssoManage',
          component: ssoManage
        },
        // 接口集成-简历
        {
          path: 'resume',
          name: 'resumeManage',
          component: resumeManage
        },
        // 接口集成-简历
        {
          path: 'business',
          name: 'BusinessManage',
          component: BusinessManage
        },
        // 接口集成-展会设置
        {
          path: 'exhibition',
          name: 'Exhibition',
          component: Exhibition
        },
        // 平台模版
        {
          path: 'Template',
          name: 'TemplateMain',
          component: TemplateMain,
          children: [
            {
              path: 'target',
              name: 'TargetTemplate',
              component: TargetTemplate
            },
            {
              path: 'appraisal',
              name: 'AppraisalTemplate',
              component: AppraisalTemplate
            },
            {
              path: 'templateSetting',
              name: 'AppraisalTemplateSetting',
              component: AppraisalTemplateSetting
            },
            {
              path: 'platform',
              name: 'PlatformTemplate',
              component: PlatformTemplate
            },
            {
              path: 'socialSecurityScheme',
              name: 'SocialSecurityScheme',
              component: SocialSecurityScheme
            },
            {
              path: 'srlTemplate',
              name: 'SrlTemplate',
              component: SrlTemplate
            }
          ]
        },
        {
          path: 'platformTemlateList',
          name: 'platformTemlateList',
          component: PlatformTemlateList
        },
        {
          path: 'workbenchManage',
          name: 'WorkbenchManage',
          component: WorkbenchManage
        },
        {
          path: 'knowledgeManage',
          name: 'KnowledgeManage',
          component: KnowledgeManage
        },
        {
          path: 'libraryManage',
          name: 'LibraryManage',
          component: LibraryManage
        },
        {
          path: 'mailManage',
          name: 'MailBackstageMain',
          component: MailBackstageMain
        },
        {
          path: 'personnelMatrix',
          name: 'PersonnelMatrix',
          component: PersonnelMatrix
        },
        {
          path: 'matrixDetails',
          name: 'MatrixDetails',
          component: MatrixDetails
        }
      ]
    },
    /** 自定义模块 */
    {
      path: '/customLayout',
      name: 'CustomLayout',
      component: CustomLayout,
      children: [
        {
          path: 'content',
          name: 'CustomContent',
          component: CustomContent
        },
        {
          path: 'approval',
          name: 'CustomApproval',
          component: CustomApproval
        },
        {
          path: 'settings',
          name: 'CustomSettings',
          component: CustomSettings,
          children: [
            {
              path: 'auth',
              name: 'DataAuth',
              component: DataAuth
            },
            {
              path: 'share',
              name: 'DataShare',
              component: DataShare
            },
            {
              path: 'pageAuth',
              name: 'PageAuth',
              component: PageAuth
            },
            {
              path: 'recordLocking',
              name: 'RecordLocking',
              component: RecordLocking
            },
            {
              path: 'autoMatch',
              name: 'AutoMatch',
              component: AutoMatch
            },
            {
              path: 'tabManage',
              name: 'TabManage',
              component: TabManage
            },
            {
              path: 'submenu',
              name: 'SubMenu',
              component: SubMenu
            },
            {
              path: 'depend',
              name: 'FieldDepend',
              component: FieldDepend
            },
            {
              path: 'transfer',
              name: 'FieldTransfer',
              component: FieldTransfer
            },
            {
              path: 'style',
              name: 'RecordStyle',
              component: RecordStyle
            },
            {
              path: 'workflow',
              name: 'WorkflowAuto',
              component: WorkflowAuto
            },
            {
              path: 'seas',
              name: 'HighSeas',
              component: HighSeas
            },
            {
              path: 'notSeasRule',
              name: 'NotSeasRule',
              component: NotSeasRule
            },
            {
              path: 'notice',
              name: 'NoticePush',
              component: NoticePush
            },
            {
              path: 'print',
              name: 'PrintSetting',
              component: PrintSetting
            },
            {
              path: 'links',
              name: 'OutLinks',
              component: OutLinks
            },
            {
              path: 'submitCheck',
              name: 'SubmitCheck',
              component: SubmitCheck
            },
            {
              path: 'shortMessageTemplate',
              name: 'ShortMessageTemplate',
              component: ShortMessageTemplate
            },
            {
              path: 'customButton',
              name: 'CustomButton',
              component: CustomButton
            },
            {
              path: 'checkRepeatSetting',
              name: 'CheckRepeatSetting',
              component: CheckRepeatSetting
            },
            {
              path: 'smartPlugIn',
              name: 'SmartPlugIn',
              component: SmartPlugIn
            },
            {
              path: 'mapModeSetting',
              name: 'MapModeSetting',
              component: MapModeSetting
            },
            {
              path: 'fileDownloadAuth',
              name: 'FileDownloadAuth',
              component: FileDownloadAuth
            }
          ]
        },
        {
          path: 'WEB',
          name: 'CustomWebform',
          component: CustomWebform
        },
        {
          path: 'perationFlow',
          name: 'CustomoPerationFlow',
          component: CustomoPerationFlow
        }
      ]
    },
    /** 应用中心详情 */
    /** 独立路由页 */
    {
      path: '/appReview',
      name: 'AppReview',
      component: AppReview
    },
    {
      path: '/mailDetailPage',
      name: 'mailDetailPage',
      component: mailDetailPage
    },
    {
      path: '/juheCreate',
      name: 'juheCreate',
      component: juheCreate
    },
    {
      path: '/dataLinkDetails',
      name: 'DataLinkDetails',
      component: DataLinkDetails
    },
    // 平台模版常用字段路由
    {
      path: '/platformCommonFields',
      name: 'platformCommonFields',
      component: PlatformCommonFields
    },
    // 平台模版模块布局路由
    {
      path: '/platformTemplateModule',
      name: 'platformTemplateModule',
      component: PlatformTemplateModule
    },
    {
      path: '**',
      redirect: {
        name: 'login'
      },
      component: loginNew
    }
  ]
})
export default router
